<template>
  <div
    class="container-fluid px-0"
    v-for="(fundList, fundType) in funds"
    :key="fundType"
  >
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 py-2 d-flex mt-4 account-head">
          {{ fundType }}
          <!-- This will show 'Unrestricted' or 'Temporarily_Restricted' -->
          <el-icon class="mt-2 ml-1" :size="20"><QuestionFilled /></el-icon>
        </div>
      </div>

      <!-- Loop through funds in this group -->
      <div
        class="row row-border align-items-center justify-content-between py-2"
        v-for="(itm, indx) in fundList"
        :key="itm.id"
      >
        <div class="col-6 col-md-3">
          <div class="fw-500 text-dak s-14">{{ itm.name }}</div>
        </div>
        <div class="col-6 col-md-2 text-right">
          <el-icon
            data-toggle="modal"
            data-target="#fundModal"
            :size="20"
            @click="editAccount(fundType, itm)"
            class="c-pointer mx-2"
          >
            <EditPen />
          </el-icon>
          <el-icon
            class="c-pointer"
            :size="20"
            @click="deleteAccount(itm.id, fundType, indx)"
          >
            <Delete />
          </el-icon>
        </div>
      </div>

      <!-- Add New Fund -->
      <div class="row">
        <div class="col-10 offset-md-2 text-center text-md-left">
          <div class="add-account py-2">
            <a
              @click="selectAccountType(fundType)"
              class="c-pointer text-decoration-none d-flex primary-text"
              data-toggle="modal"
              data-target="#fundModal"
            >
              <el-icon class="mr-1" :size="20"><CirclePlus /></el-icon>
              <span class="fw-500 s-14">Add a new Account</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="modal fade"
      id="fundModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="fundModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="exampleModalLabel">
              Add Fund
            </h5>
            <el-button class="close" data-dismiss="modal" aria-label="Close">
              <!-- <span aria-hidden="true" class="mt-0" ><el-icon :size="20"><Close /></el-icon></span> -->
              <span aria-hidden="true" class="mt-1" ref="closeModalBtn"
                ><el-icon :size="20"><Close /></el-icon
              ></span>
            </el-button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="!savingFund">
              <div class="col-md-12">
                <div class="row my-3">
                  <div class="col-md-3 text-md-right">
                    <label for="">Fund type</label>
                  </div>
                  <div class="col-md-8">
                    <el-dropdown trigger="click" class="w-100 mt-2">
                      <span class="el-dropdown-link w-100">
                        <div
                          class="d-flex justify-content-between border-contribution w-100"
                          size="large"
                        >
                          <div>
                            {{
                              selectedFundType
                                ? selectedFundType
                                : "Select fund type"
                            }}
                          </div>
                          <div>
                            <el-icon class="el-icon--right">
                              <arrow-down />
                            </el-icon>
                          </div>
                        </div>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(itm, indx) in fundTypes"
                            :key="indx"
                          >
                            <div
                              @click="selectFundType(itm)"
                              class="col-md-12 px-2"
                            >
                              {{ itm }}
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <!-- <el-select-v2
                        v-model="selectedFundTypeID"
                        class="w-100 font-weight-normal"
                        :options="
                          funds.map((i) => ({
                            label: i,
                            value: i,
                          }))
                        "
                        placeholder="Select account currency"
                        @change="selectFundType"
                        size="large"
                      /> -->
                    <!-- <button class="  btn d-flex justify-content-between  col-12 border  " type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="ofering">
                                &nbsp;&nbsp;&nbsp; {{ selectedFundType ?  selectedFundType : 'Select account currency' }}
                            </span>
                            <span>
                                <i class="pi pi-angle-down offset-sm-2 ofering"></i>
                            </span>
                        </button> -->
                    <!-- <div class="dropdown-menu scroll w-100 " aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" v-for="(itm, indx) in fundTypes" :key="indx">
                                <div class="cursor-pointer" @click="selectFundType(itm)"> {{itm}}</div> 
                            </a>
                        </div> -->
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-md-3 text-md-right">
                    <label for="">Fund name</label>
                  </div>
                  <div class="col-md-8">
                    <el-input
                      type="text"
                      v-model="newFund.name"
                      placeholder="Enter fund name"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-5" v-if="savingFund">
              <div class="col-md-12 text-center">
                <el-icon :size="20" class="is-loading">
                  <Loading />
                </el-icon>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-end">
                  <el-button round class="mr-3" data-dismiss="modal">
                    Cancel
                  </el-button>
                  <el-button
                    @click="onSave"
                    round
                    :loading="savingFund"
                    :color="primarycolor"
                    :disabled="!selectedFundType || !newFund.name"
                    class="border-0 text-white"
                  >
                    Save
                  </el-button>
                  <!-- <button class="default-btn mr-3" data-dismiss="modal" ref="closeModalBtn">
                      Cancel
                    </button>
                    <button
                      @click="onSave"
                      class="default-btn primary-bg border-0 text-white"
                      
                    >
                      Save
                    </button> -->
                </div>
              </div>
            </div>
          </div>

          <!-- <Toast /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject } from "vue";
import transactionUtil from "./utilities/transactionals";
import chart_of_accounts from "../../../services/financials/chart_of_accounts";
import transactionals from "./utilities/transactionals";
import { ElNotification, ElMessageBox } from "element-plus";

export default {
  props: ["data"],
  components: {},

  setup(props, { emit }) {
    const accounts = ref([]);
    const funds = ref([]);
    const primarycolor = inject("primarycolor");
    const fundTypes = ref([]);
    const singleFund = ref([]);
    const selectedFundType = ref("");
    const selectedGroupId = ref("");
    const accountToEdit = ref({});

    const selectFundType = (item) => {
      selectedFundType.value = item;
      console.log(selectedFundType.value, "jkhljkhlk");
    };

    const getAccounts = async () => {
      try {
        accounts.value = await transactionUtil.getTransactionalAccounts();
        console.log(accounts.value);
      } catch (error) {
        console.log(error);
      }
    };
    getAccounts();

    const getOneFund = async (id) => {
      if (!id) {
        return false;
      } else {
        try {
          singleFund.value = await chart_of_accounts.getOneFund(id);
          console.log(singleFund.value, "xnnn");
          newFund.value.name = singleFund.value.name;
          selectedFundType.value =
            singleFund.value.fundType === 0
              ? "Unrestricted"
              : "Temporarily_Restricted";
        } catch (error) {
          console.log(error);
        }
      }
    };
    getOneFund();

    // const getFunds = async () => {
    //   try {
    //     funds.value = await transactionUtil.getFunds();
    //     console.log(funds.value, 'funds');
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    // getFunds();
    const getFunds = async () => {
      try {
        const fetchedFunds = await transactionUtil.getFunds();
        funds.value = fetchedFunds;
        fundTypes.value = [
          ...new Set(fetchedFunds.map((fund) => fund.fundType)),
        ];

        // Group by fundType
        const groupedFunds = fetchedFunds.reduce((acc, fund) => {
          const key = fund.fundType;

          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(fund);
          return acc;
        }, {});

        funds.value = groupedFunds;
        console.log(funds.value, "Grouped funds");
      } catch (error) {
        console.log(error);
      }
    };

    getFunds();

    const currencyList = ref([]);
    const getCurrencies = async () => {
      try {
        currencyList.value = await transactionUtil.getCurrencies();
        console.log(currencyList.value);
      } catch (error) {
        console.log(error);
      }
    };
    getCurrencies();

    const closeModalBtn = ref(null);
    const savingFund = ref(false);
    const saveFund = async (fund) => {
      try {
        savingFund.value = true;
        let response = {};
        if (accountToEdit.value.id) {
          accountToEdit.value.name = fund.name;
          response = await chart_of_accounts.editFund(fund);
        } else {
          response = await chart_of_accounts.saveFund(fund);
        }
        savingFund.value = false;
        closeModalBtn.value.click();
        if (!response.status) {
          emit("save-fund", {
            success: false,
            message: "An error ocuurred, please try again",
          });
          ElNotification({
            type: "error",
            message: "Fund Creation Failed",
            duration: 3000,
          });
        } else {
          ElNotification({
            type: "success",
            message: `The fund ${newFund.value.name} was created successfully`,
            duration: 3000,
          });
          emit("save-fund", {
            success: true,
            message: "Fund Successfully Saved",
          });
          transactionals.getFunds(true);
        }
      } catch (error) {
        savingFund.value = false;
        // ElMessage({
        //           type: "success",
        //           message: "Fund Successfully Saved",
        //           duration: 3000,
        //         });
        console.log(error);
      }
    };

    const newFund = ref({});
    // const fundTypeMap = {
    //   Unrestricted: 0,
    //   Temporarily_Restricted: 1,
    // };
    const fundTypeMap = {
      Unrestricted: { id: 0, groupName: "Unrestricted Funds" },
      Temporarily_Restricted: { id: 1, groupName: "Donor Restricted Funds" },
    };
    const onSave = () => {
      if (!selectedFundType.value || !newFund.value.name) {
        return false;
      }

      // Convert fundType string to numeric value
      newFund.value.fundType = fundTypeMap[selectedFundType.value].id ?? 0;
      newFund.value.financialAccountGroupID =
        newFund.value.financialAccountGroupID = getGroupIdByFundType(
          selectedFundType.value
        );

      saveFund(newFund.value);
    };

    const accountTypes = transactionUtil.accountTypes;

    const selectAccountType = (group) => {
      // selectedGroupId.value = item.id;
      selectedFundType.value = group.name;
    };

    const getGroupIdByFundType = (fundTypeKey) => {
      const fundGroupName = fundTypeMap[fundTypeKey]?.groupName;
      if (!fundGroupName) return null;

      const group = props.data.accountHeadsDTO.find(
        (head) => head.name === fundGroupName
      );

      return group ? group.id : null;
    };
    const editAccount = (group, account) => {
      getOneFund(account.id);
      accountToEdit.value = account;
      newFund.value.name = accountToEdit.value.name;
      newFund.value.code = accountToEdit.value.code;
      newFund.value.id = accountToEdit.value.id;
      newFund.value.fundType = group;
      newFund.value.financialAccountGroupID = getGroupIdByFundType(
        selectedFundType.value
      );
      // selectedFundType.value = group;
    };

    const deleteAccount = (id, index, indx) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(async () => {
          try {
            const response = await chart_of_accounts.deleteFund(id);
            if (response.status) {
              ElNotification({
                type: "success",
                message: `${response.response}`,
                duration: 3000,
              });
            } else {
              ElNotification({
                type: "error",
                message: `${response.response}`,
                duration: 3000,
              });
            }
            // funds.value = funds.value.filter((fund) => fund.id !== id);
            // funds.value[index].splice(indx, 1);

            emit("fund-deleted", index, indx);
          } catch (error) {
            ElNotification({
              type: "error",
              message: "Account not deleted",
              duration: 3000,
            });
            console.log(error);
          }
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
            duration: 5000,
          });
        });
    };

    return {
      accountTypes,
      selectFundType,
      primarycolor,
      currencyList,
      accounts,
      funds,
      onSave,
      fundTypes,
      newFund,
      selectedFundType,
      savingFund,
      closeModalBtn,
      selectAccountType,
      editAccount,
      accountToEdit,
      deleteAccount,
    };
  },
};
</script>

<style scoped>
.row-border {
  border-bottom: 1px solid #b0b0b0;
}

.account-head {
  background: #eeeeee;
  font-weight: 500;
  font-size: 20px;
}

.help {
  color: rgb(100, 100, 100);
  margin: 5px;
}

.desc {
  color: #190138;
  opacity: 0.6;
}

.desc-head {
  font-weight: 600;
}

.add-account {
  color: #0745af;
  font-weight: 600;
}

.modal-lg {
  max-width: 670px;
}
</style>
